import printsHtml from './configuratorPrintsAdm.html';

class configuratorPrintsAdmController {
    constructor($scope, $timeout, printsService) {
        'ngInject';

        this.$scope = $scope;
        this.debug = false;
        this.saved = true;
        this.saving = false;
        this.service = printsService;
        this.prices = {};
        this.printModes = {};
        this.areas = [
            1, 5, 10, 20, 50, 100, 200, 500
        ];
        this.areasMultipliersPercentage = {};

        this.service.getPrices().then(
            response => {
                this.initPrices(response.data);
            },
            response => {
                alert('Wystąpił nieoczekiwany błąd! Skontaktuj się z administratorem.');
            }
        )

        this.service.getPrintModes().then(
            response => {
                this.printModes = response;
            },
            response => {
                alert('Wystąpił nieoczekiwany błąd! Skontaktuj się z administratorem.');
            }
        )
    }

    initPrices(prices) {
        this.prices = prices;

        if (!prices || Object.keys(this.prices).length === 0) {
            return;
        }

        for (const [area, multiplier] of Object.entries(this.prices.multipliers.area)) {
            this.areasMultipliersPercentage[area] = Math.round((multiplier * 100 - 100) * 100) / 100;
        }

        this.$scope.$watch(() => this.areasMultipliersPercentage, (newVal, oldVal) => {
            for (const [area, multiplierPercentage] of Object.entries(this.areasMultipliersPercentage)) {
                this.prices.multipliers.area[area] = parseInt(multiplierPercentage) / 100 + 1;
            }
        }, true);
    }

    get ready() {
        return this.prices && Object.keys(this.prices).length > 0 && Object.keys(this.printModes).length > 0;
    }

    getPrintModeAreaPrice(printMode, area) {
        const areaMultiplier = this.prices.multipliers.area[area];
        const printModeMultiplier = this.prices.multipliers.print_mode[printMode];
        const printPrice = this.prices.base;

        return printPrice * printModeMultiplier * areaMultiplier;
    }

    save() {
        this.saving = true;
        this.service.savePrices(this.prices).then(
            response => {
                this.saving = false;
                this.saved = true;
                this.initPrices(response.data);
            },
            response => {
                this.saving = false;
                this.saved = false;
                alert("Nie udało się zapisać danych! Skontaktuj się z administratorem.");
            }
        );
    }
}

let configuratorPrintsAdmComponent = {
    bindings: {},
    template: printsHtml,
    controller: configuratorPrintsAdmController
};

export default configuratorPrintsAdmComponent;
